import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { store } from 'redux-rest-reducer';
import styled from 'styled-components';

import { renderFormField } from 'modules/form';
import { studentTrialUpgradeFields } from 'constants/form';
import { Button, Row, Separator } from '@cuemath/comps';
import BallLoader from 'comps/ball-loader';
import { Message } from 'modules/form';

import {
  post as trialUpgradeStudentCourse,
  emptyStoreData,
} from 'actions/student-course-trial-upgrade';
import { closeModal } from 'actions/modal';

const Wrapper = styled.div`
  padding: 40px 10px 20px;
`;

const StudentTrialUpgradeForm = ({
  studentCourseTrialUpgrade,
  studentCourse,
  trackEventFunc,
  actions,
}) => {
  const [form, setForm] = useState(getFormDefaults());
  const [fields] = useState(studentTrialUpgradeFields);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const { id: studentCourseId } = studentCourse || {};

  const studentCourseTrialUpgradePostData = store.post(
    studentCourseTrialUpgrade,
    studentCourseId,
  );
  const { resolved: postDataResolved } = studentCourseTrialUpgradePostData || {};
  const errorObj = postDataResolved && store.getError(postDataResolved);
  const { message } = errorObj || {};
  const { data: postData, isCreated, isCreatingFailed } = postDataResolved || {};
  const {
    discount_amount: discountAmount,
    pending_classes: pendingClasses,
    transition_state: transitionState,
    trial_upgrade_initiated: trialUpgradeInitiated,
  } = postData || {};

  const fillForm = () => {
    if (discountAmount === undefined || pendingClasses === undefined) return;

    let newForm = {};
    newForm.discount_amount = discountAmount;
    newForm.pending_classes = pendingClasses.toString();

    setForm({ ...form, ...newForm });
  };

  const onCloseModal = () => {
    setTimeout(() => {
      setSuccess(false);
      actions.closeModal();
    }, 1500);
  };

  useEffect(() => {
    const postData = {
      action: 'get_trial_upgrade_details',
    };
    actions.trialUpgradeStudentCourse(studentCourseId, postData);
    setLoading(true);
    return () => {
      actions.emptyStoreData({ items: {} });
    };
  }, []);

  useEffect(() => {
    if (isCreated) {
      trackEventFunc('trial_upgrade');
      if (trialUpgradeInitiated) {
        setSuccess(true);
        onCloseModal();
      } else {
        fillForm();
      }
      setLoading(false);
    } else if (isCreatingFailed) {
      if (message) {
        setError(message);
      } else {
        setError('Something went wrong!');
      }
      setLoading(false);
    }
  }, [isCreated, isCreatingFailed]);

  function getFormDefaults() {
    const formDefaults = {};

    studentTrialUpgradeFields.forEach(field => {
      formDefaults[field.name] = field.default;
    });
    return formDefaults;
  }

  const onConfirm = () => {
    const postData = {
      action: 'initiate_trial_upgrade_process',
      action_data: {},
    };
    setLoading(true);
    actions.trialUpgradeStudentCourse(studentCourseId, postData);
  };

  const buttonLabel =
    transitionState === 'CONFIRMED' ? 'Trial Upgrade confirmed.' : 'Submit';

  const isButtonDisabled = transitionState === 'CONFIRMED' || trialUpgradeInitiated;

  return (
    <Wrapper>
      {fields &&
        fields.map(field =>
          renderFormField({
            ...field,
            value: form[field.name],
          }),
        )}
      {error && (
        <Message width="100%" error>
          {error}
        </Message>
      )}
      {success ? (
        <Message width="100%">Link sent to Parents</Message>
      ) : (
        <>
          <Separator transparent height="20" />
          <Row justifyContent="center">
            {loading ? (
              <BallLoader />
            ) : (
              <Button
                align="center"
                label={buttonLabel}
                onClick={onConfirm}
                disabled={isButtonDisabled}
              />
            )}
          </Row>
        </>
      )}
    </Wrapper>
  );
};

export default connect(
  ({ studentCourseTrialUpgrade }) => {
    return { studentCourseTrialUpgrade };
  },
  dispatch => ({
    actions: bindActionCreators(
      {
        trialUpgradeStudentCourse,
        emptyStoreData,
        closeModal,
      },
      dispatch,
    ),
  }),
)(StudentTrialUpgradeForm);
